<template>
  <loading-progress
    v-if="isLoading"
    :progress="60"
    :indeterminate=true
    :hide-background="true"
    size="64"
    rotate
    fillDuration="2"
    rotationDuration="1"
  />
  <div class="dboard-card" v-else>
    <div class="row">
      <div class="col-lg-12">
        <div class="dboard-card-title">
          KPIs
        </div>
        <div v-if="kpidata.length>0" v-for="(chart, index) in kpidata"
          :key="index" class="kpi-holder">
          <KPIChart v-if="chart.type === 'hbar_percentile'"
          :values="chart.values" :labels="chart.labels"/>
          <span v-else class="dboard-card-section-sectitle primary-text">Chart Not Available</span>
        </div>
        <span v-else class="dboard-card-section-sectitle primary-text">No Records</span>
      </div>
    </div>
  </div>
</template>
<script>
/* eslint-disable */
import KPIChart from '../common/charts/KPIChart';

export default {
  props: {
    kpidata: {
      type: Array,
    },
    isLoading: {
      type: Boolean,
    },
  },
  components: {
    KPIChart,
  },
}
</script>
<style lang="scss">
.kpi-holder {
  &:nth-child(2) {
    margin-top: 15px;
  }
}
</style>
